import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './header.css';

export default function Header() {
  const { t } = useTranslation();

  return (
    <header id='navigation'>
      <nav aria-label='Main navigation'>
        <ul className='nav-list'>
          <li>
            <NavLink 
              to='/' 
              className={({ isActive }) => 
                `nav-item ${isActive ? 'active' : ''}`
              }
              end
            >
              {t('header.home')}
            </NavLink>
          </li>

          <li>
            <NavLink 
              to='/about' 
              className={({ isActive }) => 
                `nav-item ${isActive ? 'active' : ''}`
              }
            >
              {t('header.about')}
            </NavLink>
          </li>

          <li>
            <NavLink 
              to='/work' 
              className={({ isActive }) =>
                `nav-item ${isActive ? 'active' : ''}`
              }
            >
              {t('header.work')}
            </NavLink>
          </li>

          <li>
            <a
              href='mailto:moe.kamimoto@gmail.com'
              className='nav-item'
              aria-label='Email: moe.kamimoto@gmail.com'
            >
              {t('header.contact')}
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
